<template>
  <div class="w-full" :key="order.updated_at">
    <h1 class="mb-8 font-bold text-lg md:text-2xl">
      <inertia-link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('customer.orders')"
      >
        Customer Orders
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Order #{{ order.id }}
    </h1>
    <div class="grid grid-cols-1 sm:grid-cols-12 gap-6">
      <div class="sm:col-span-12">
        <div>
          <OrderTabs active="fulfillment" :order-id="order.id" />
          <OrderTabContent>
            <OrderFulfillmentDetails
              class="!bg-transparent !shadow-none -mt-0"
              :order-id="order.id" ref="orderfulfillment"
              :warehouses="warehouseList"
            />
          </OrderTabContent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "../../../Shared/Admin/Layout.vue";
import OrderTabs from "./Partials/OrderTabs.vue";
import OrderTabContent from "./Partials/OrderTabContent.vue";
import OrderFulfillmentDetails from "./OrderFulfillmentDetails.vue";

export default {
  name: 'DeliveryDetails',
  components: {OrderFulfillmentDetails, OrderTabContent, OrderTabs},
  layout: Layout,
  metaInfo: { title: 'Orders Fulfillment Details' },

  props: {
    order: Object,
    warehouseList: Array,
  }
}
</script>
